import { useState, useCallback } from 'react';
import { fetchTaskHtml } from '../../services/TaskService';

export const useTaskHtml = () => {
  const [html, setHtml] = useState('');
  const [isLoadingHtml, setIsLoadingHtml] = useState(false);
  const [htmlError, setHtmlError] = useState(null);

  const getTaskHtml = useCallback(async (taskId) => {
    if (!taskId || taskId <= 0) {
      const error = new Error('TaskId must be greater than zero.');
      console.error(error.message);
      setHtmlError(error);
      return { ok: false, error };
    }

    setIsLoadingHtml(true);
    setHtmlError(null);

    try {
      const htmlResponse = await fetchTaskHtml(taskId);
      setHtml(htmlResponse || '');
      return {
        ok: true,
        data: htmlResponse,
      };
    } catch (error) {
      console.error('Error obteniendo HTML de la tarea:', error);
      setHtmlError(error);

      return {
        ok: false,
        error,
      };
    } finally {
      setIsLoadingHtml(false);
    }
  }, []);

  return {
    html,
    setHtml,
    isLoadingHtml,
    htmlError,
    getTaskHtml,
  };
};
